import React, { useEffect  } from 'react'
import materialtextures from './config/material.json'
import Structure from './liftcomponents/Structure'
import InterFloor from './liftcomponents/Interfloor'
import BackWall from './liftcomponents/BackWall'
import Wall from './liftcomponents/Wall'
import Door from './liftcomponents/Door'
import DoorBorders from './liftcomponents/DoorBorders'

//const wallThickness = 4 //centimeters

export default function Floor(props) {
  //const [hovered, set] = useState(null)
  const hovered = false
  const doorOffsets = 2.5 //centimeters

  useEffect(() => {
    document.body.style.cursor = hovered ? 'copy' : 'default'
  }, [hovered])



  const walls = Object.keys(props.walls).map((side,k)=>{
    const wall=props.walls[side]
    const hasdoor=props.doors[side] !== undefined
      return(
      <Wall 
          key={`wall-${k}`}
          side={side} 
          material={wall.material} 
          type={wall.type} 
          texture={materialtextures[wall.material][wall.texture]} 
          dim={props.dim} 
          structuresize={props.structure.size}
          elevation={hasdoor?props.cabin.height-props.dim[2]/2+doorOffsets:null}
      />
    )
  })

  const doors = Object.keys(props.doors).map((side,k)=>{
    const door = props.doors[side]
    return(
      <group key={`doors-${k}`}>
        <Door 
            key={`door-${k}`}
            side={side} 
            material={door.material} 
            type={door.type} 
            texture={materialtextures[door.material][door.texture]} 
            dim={props.dim} 
            doorheight={props.cabin.height}
            structuresize={props.structure.size}
        />

        <DoorBorders 
            key={`doorborder-${k}`}
            side={side} 
            material={props.structure.material} 
            type={props.structure.type} 
            texture={materialtextures[props.structure.material][props.structure.texture]} 
            dim={props.dim} 
            doorheight={props.cabin.height}
            structuresize={props.structure.size}
        />
      </group>

    )
  })


  return (
      <group 
        position={props.position}
        dispose={null}
        /*onClick={ e=>{e.stopPropagation(); props.onClick( e.object.item )}}
        onPointerOver={ e=>{e.stopPropagation(); set(true)}}
        onPointerOut={ e=>{e.stopPropagation(); set(false)}}*/
      >

        <Structure 
                  key='structure'
                  material={props.structure.material} 
                  type={props.structure.type} 
                  texture={materialtextures[props.structure.material][props.structure.texture]} 
                  dim={props.dim} 
                  size={props.structure.size}
        />


        <BackWall 
                  key='backwall'
                  material={props.backwall.material} 
                  type={props.backwall.type} 
                  texture={materialtextures[props.backwall.material][props.backwall.texture]} 
                  dim={props.dim} 
                  size={props.structure.size}
/>
        <InterFloor 
                  key='interfloor'
                  material={props.ceil.material} 
                  type={props.ceil.type} 
                  texture={materialtextures[props.ceil.material][props.ceil.texture]} 
                  dim={props.dim} 
                  size={props.structure.size} 
                  ceilHeight={props.ceil.height}
        />
        
        {walls}
        {doors}
        <pointLight position={[0, props.dim[2], 0]}  color='#f0f0ff' castShadow/>
      </group>    
  )
}
